import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-1.5" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-between px-1 pb-0.5"
}
const _hoisted_3 = {
  key: 0,
  class: "px-1 text-xs leading-relaxed text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    ($props.title || _ctx.$slots['header-action'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", {
            class: _normalizeClass(["text-sm font-medium", $props.variant === 'danger' ? 'text-red-700' : 'text-gray-700'])
          }, _toDisplayString($props.title), 3 /* TEXT, CLASS */),
          _renderSlot(_ctx.$slots, "header-action")
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["overflow-hidden rounded-lg border bg-white shadow-sm", [
                $props.variant === 'danger' ? 'border-red-200' : 'border-gray-200',
                $props.divided ? 'divide-y divide-gray-100' : '',
            ]])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _renderSlot(_ctx.$slots, "footer", {}, () => [
      ($props.footer)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.footer), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}